export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-user-heart-line',
      title: 'Terapia Individual',
      description: 'Sesiones personalizadas para trabajar en tu crecimiento personal, autoestima, ansiedad, depresión y otros desafíos emocionales. Un espacio seguro para explorar tus pensamientos y sentimientos.',
      image: 'https://public.readdy.ai/ai/img_res/441db56f7da33446ad3f70d0dd371780.jpg'
    },
    {
      icon: 'ri-heart-2-line',
      title: 'Terapia de Pareja',
      description: 'Fortalece tu relación y mejora la comunicación con tu pareja. Trabajamos juntos para resolver conflictos, reconstruir la confianza y crear una conexión más profunda y significativa.',
      image: 'https://readdy.ai/api/search-image?query=Couple%20therapy%20session%20in%20a%20warm%20inviting%20counseling%20room%20with%20two%20people%20sitting%20comfortably%20discussing%20with%20soft%20lighting%20and%20calming%20neutral%20beige%20cream%20tones%20creating%20an%20atmosphere%20of%20trust%20understanding%20and%20emotional%20connection%20with%20plants%20and%20peaceful%20decor%20promoting%20relationship%20healing&width=600&height=400&seq=service002&orientation=landscape'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Bienestar Emocional',
      description: 'Aprende herramientas prácticas para manejar el estrés, desarrollar resiliencia emocional y cultivar hábitos saludables que promuevan tu bienestar integral y calidad de vida.',
      image: 'https://readdy.ai/api/search-image?query=Wellness%20and%20emotional%20health%20concept%20with%20peaceful%20meditation%20space%20featuring%20soft%20natural%20light%20comfortable%20cushions%20plants%20and%20calming%20neutral%20beige%20cream%20tones%20creating%20a%20tranquil%20atmosphere%20for%20mindfulness%20stress%20relief%20and%20mental%20wellbeing%20with%20minimalist%20serene%20design&width=600&height=400&seq=service003&orientation=landscape'
    },
    {
      icon: 'ri-parent-line',
      title: 'Orientación Familiar',
      description: 'Apoyo profesional para familias que enfrentan desafíos en la comunicación, crianza y dinámicas familiares. Construyamos juntos un ambiente familiar más armonioso y saludable.',
      image: 'https://readdy.ai/api/search-image?query=Family%20counseling%20environment%20with%20comfortable%20seating%20arrangement%20in%20a%20warm%20welcoming%20therapy%20room%20with%20soft%20lighting%20and%20neutral%20beige%20cream%20tones%20creating%20a%20safe%20supportive%20space%20for%20family%20discussions%20and%20healing%20with%20plants%20and%20calming%20decor%20promoting%20harmony&width=600&height=400&seq=service004&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Coaching Profesional',
      description: 'Desarrolla tu potencial profesional, supera el síndrome del impostor y alcanza tus metas laborales. Te ayudo a encontrar equilibrio entre tu vida personal y profesional.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20coaching%20session%20in%20a%20modern%20bright%20office%20space%20with%20clean%20lines%20comfortable%20seating%20natural%20lighting%20and%20neutral%20beige%20cream%20tones%20creating%20an%20inspiring%20environment%20for%20career%20development%20and%20personal%20growth%20with%20plants%20and%20motivational%20minimalist%20decor&width=600&height=400&seq=service005&orientation=landscape'
    },
    {
      icon: 'ri-emotion-line',
      title: 'Manejo de Crisis',
      description: 'Apoyo inmediato y efectivo en momentos de crisis emocional. Te acompaño en situaciones difíciles como duelo, trauma o cambios significativos en tu vida.',
      image: 'https://readdy.ai/api/search-image?query=Crisis%20intervention%20therapy%20room%20with%20calming%20atmosphere%20soft%20comfortable%20seating%20gentle%20lighting%20and%20soothing%20neutral%20beige%20cream%20tones%20creating%20a%20safe%20supportive%20space%20for%20emotional%20support%20and%20healing%20during%20difficult%20times%20with%20peaceful%20plants%20and%20serene%20decor&width=600&height=400&seq=service006&orientation=landscape'
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
            Servicios Profesionales
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ofrezco una amplia gama de servicios de psicología adaptados a tus necesidades específicas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-full mb-4">
                  <i className={`${service.icon} text-3xl text-[#14B8A6]`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3 font-['Playfair_Display']">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://wa.me/526692612777?text=Hola%2C%20me%20gustaría%20conocer%20más%20sobre%20tus%20servicios" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#14B8A6] text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-[#0F9688] transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Consulta Sobre Servicios
          </a>
        </div>
      </div>
    </section>
  );
}
